import React, { useState, useEffect } from 'react'
import { FiEdit } from 'react-icons/fi'
import { MdDeleteOutline } from 'react-icons/md'
import classes from './Teacher.module.css'
import BlueBtn from './../../Components/SidBarButtons/BlueBtn'
import { AiFillBell } from 'react-icons/ai'
import { teacher } from './../../store/teacher'
import { teacherProperty, TeacherPropertyType } from './../../store/teacherProperty'
import CheckBox from './../../Components/CheckBox/CheckBox'
import { observer } from 'mobx-react-lite'
import { delDescriptionTeacher, getTeacherProperty, getTeacherDesc, getDescriptionTeacher } from './../../Service/properties'
import ConfirmModal from './../../Components/Modal/ConfirmModal'
import NoteseTeacherModal from './../../Components/Modal/NodesModalTeacher'
import { toast } from 'react-toastify'
import http from './../../Service/http'
import { useTranslation } from 'react-i18next'
import { auth } from '../../store/auth'

type tplotOptions = {
  [key: string]: boolean
}

function TeacherProperty() {
  const notify = (title: string) => toast(title)
  const [modal, setModal] = useState({
    modal: false,
    id: 0
  })

  const [accessForm, setAccessForm] = useState<tplotOptions>({
    t_fio_pole1: false,
    t_fio_pole2: false,
    t_fio_pole3: false,
    t_fio_pole4: false,
    t_fio_pole5: false,
    t_fio_pole6: false,
    t_fio_pole7: false,
    t_fio_pole8: false,
    t_fio_pole9: false
  })

	const [confirmModal, setConfirmModal] = useState({
		modal: false,
		idDesc: 0
	})
	const closeModalNotes = () => {
		setModal({
			modal: false,
			id: 0
		})
	}
	const getProperty = async (id: number) => {
		const result = await getTeacherProperty(id)
		teacherProperty.newDolgProperty(result)
		let obj: any = {}
		const r = result.map((item: TeacherPropertyType, i: number) => {
			obj = { ...obj, [item.okno_pole]: Boolean(item.dolg) }
		})
		setAccessForm({ ...accessForm, ...obj, id_teacher: teacher.teacher.id_teacher })
		teacherProperty.newTempVar({ ...accessForm, ...obj, id_teacher: teacher.teacher.id_teacher })
	}

	const getDesc = async (id: number) => {
		const result = await getTeacherDesc(id)
		teacherProperty.newDescription(result)
	}

	useEffect(() => {
		if (teacher.teacher.id_teacher) {
			getProperty(teacher.teacher.id_teacher)
			getDesc(teacher.teacher.id_teacher)
		}
	}, [teacher.teacher.id_teacher])

  const delDesc = async () => {
    const res = await delDescriptionTeacher(confirmModal.idDesc)
    if (res) {
      const oknoDesc = await getDescriptionTeacher(teacher.teacher.id_teacher)
      teacherProperty.newDescription(oknoDesc)
      notify('Успешно удалено!')
      closeConfirmModal()
    }
  }

	const closeConfirmModal = () => {
		setConfirmModal({ modal: false, idDesc: 0 })
	}
	const { t } = useTranslation()
	return (
		<div className={classes.property}>
			<NoteseTeacherModal close={closeModalNotes} modal={modal.modal} id={modal.id} />
			<ConfirmModal title={t('st:other.confirm')} isOpen={confirmModal.modal} hundleTrue={delDesc} setIsOpen={closeConfirmModal} />
			<h3 className={classes.title}>{t('st:other.dolg')}</h3>
			<div className={classes.checkboxs}>
				{!!teacher.teacher.id_teacher &&
					teacherProperty.dolgProperty.map((item, i) => {
						return (
							<div className={classes.checkbox} style={{ opacity: !teacherProperty.accessProperty[i]?.visibles ? 0.6 : 1 }}>
								<CheckBox
									item={accessForm}
									dsbl={!teacherProperty.accessProperty[i]?.visibles}
									onchange={(e: boolean) => {
										setAccessForm(state => {
											return { ...state, [item.okno_pole]: e }
										})
									}}
									checked={accessForm[item.okno_pole]}
									active={true}
								/>
								<label className={classes.label}>{item.okno_title}</label>
							</div>
						)
					})}
			</div>
			<div className={classes.btns}>
				<BlueBtn
					dsbl={!teacher.teacher.id_teacher}
					title={t('st:other.notes')}
					onclick={() => {
						setModal({
							modal: true,
							id: 0
						})
					}}
				>
					<AiFillBell />
				</BlueBtn>
				{JSON.stringify(teacherProperty.tempVar) != JSON.stringify(accessForm) && (
					<BlueBtn
						dsbl={!teacher.teacher.id_teacher}
						title={t('st:button.save')}
						onclick={async () => {
							const res = await http.post('/teacher/teacher-propertiesui', { ...accessForm, AVN_user: auth.user.data.id })
							if (res.data) {
								await getProperty(teacher.teacher.id_teacher)
								notify(t('st:other.saved'))
							} else {
								notify(t('st:other.reject'))
							}
						}}
					>
						<AiFillBell />
					</BlueBtn>
				)}
			</div>
			<div className={classes.Descriptions}>
				<div className={classes.Descriptions_dolg}>
					{teacherProperty.desription.map((item, i) => {
						return (
							<div className={classes.Description_item} key={item.id_okno_description_teacher}>
								<p>
									Примечание: &nbsp;
									{item.okno_description}
									<FiEdit
										className={classes.descEditBtn}
										onClick={() => {
											setModal({
												modal: true,
												id: item.id_okno_description_teacher
											})
										}}
									/>
									<MdDeleteOutline
										className={classes.descEditBtn}
										onClick={async () => {
											setConfirmModal({
												modal: true,
												idDesc: item.id_okno_description_teacher
											})
										}}
									/>
								</p>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
}

export default observer(TeacherProperty)
